import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated } = useAuth();

    if (!isAuthenticated) {
        // Redirect to login page and save the attempted URL using window.location
        // This avoids the useLocation() timing issue in production builds
        const fromLocation = {
            pathname: window.location.pathname,
            search: window.location.search,
            hash: window.location.hash,
            state: null,
            key: 'protected-route-redirect'
        };
        
        return <Navigate to="/login" state={{ from: fromLocation }} replace />;
    }

    return children;
};

export default ProtectedRoute; 